import axios from 'axios'
import { ToastPlugin } from 'bootstrap-vue'

import store from '../store'

axios.defaults.baseURL = process.env.VUE_APP_API_URL + 'api/'
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`

axios.interceptors.request.use((config) => {
  store.commit('toggleLoading', true)

  return config
}, function (error) {
  handleError(error)
  
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  store.commit('toggleLoading', false)

  return response
}, function (error) {
  handleError(error)

  return Promise.reject(error)
})

function handleError (error) {
  // console.error(error)

  let errorOutput = error

  if (error.response) {
    errorOutput = error.response.data.message ? error.response.data.message : error.response.data
  }

  if (error.response.status === 500) {
    console.log(errorOutput)

    store.commit('error/errorOccurred', 'Terjadi Kesalahan')
  } else if (error.response.status === 401) {
    store.commit('error/errorOccurred', 'Sesi anda telah habis, mohon login kembali')

    store.commit('user/logout')
  } else if (error.response.status !== 404) {
    store.commit('error/errorOccurred', errorOutput)
  } else {
    store.commit('error/errorOccurred', errorOutput)
  }
  
  store.commit('toggleLoading', false)
}

export default axios